// extracted by mini-css-extract-plugin
module.exports = {"root":"RangeSlider_root__Eg781","activeHandle":"RangeSlider_activeHandle__LTnq6"};